import { render, staticRenderFns } from "./TargetAndRewardValues.vue?vue&type=template&id=9fa28e16&scoped=true&"
import script from "./TargetAndRewardValues.vue?vue&type=script&lang=js&"
export * from "./TargetAndRewardValues.vue?vue&type=script&lang=js&"
import style0 from "./TargetAndRewardValues.vue?vue&type=style&index=0&id=9fa28e16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa28e16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fa28e16')) {
      api.createRecord('9fa28e16', component.options)
    } else {
      api.reload('9fa28e16', component.options)
    }
    module.hot.accept("./TargetAndRewardValues.vue?vue&type=template&id=9fa28e16&scoped=true&", function () {
      api.rerender('9fa28e16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/Task/components/TargetAndRewardValues.vue"
export default component.exports